/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Coworking page component
import AboutUsOption from "pages/Produtos/components/AboutUsOption";

function AboutUs() {
  return (
    <MKBox component="section" py={{ xs: 3, md: 12 }}>
      <Container>
        <Grid container>
          <Grid item xs={12} lg={5}>
            <MKTypography variant="h3" my={1}>
              Desenhado para o cliente
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={2}>
              Nossos produtos são exclusivos, e assim como as nossas soluções são desenhados para atender
              às necessidades de nossos clientes.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
            <Stack>
              <AboutUsOption
                icon="mediation"
                content={
                  <>
                    Soluções integradas e construídas para a sua necessidade.
                    <br />
                    Nossos consultores em parceria com o cliente para um resultado único.
                  </>
                }
              />
              <AboutUsOption
                icon="settings_overscan"
                content={
                  <>
                    Montagem e/ou fabricação no Brasil.
                    <br />
                  </>
                }
              />
              <AboutUsOption
                icon="token"
                content={
                  <>
                    Fornecedores exclusivos, em toda América Latina, da MDC-SR10 V2, e
                    <br />
                    software desenvolvido para perfeita integração com o data center.
                  </>
                }
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AboutUs;
